import { createFileRoute } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/servers"
)({
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.servers.read),
  loader: () => ({
    crumb: "Servers",
  }),
});
